// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"f7c368fe","126":"f488edb4","715":"aa5566a4","792":"bb68f6b8","798":"62748e59","812":"3d473076","944":"221597c0"}[chunkId] + ".chunk.js";
};